import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NavService } from '../providers/nav.service';
// import { Cookie } from 'ng2-cookies/ng2-cookies';
import { ApiService } from '../providers/api.service';
// import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
// import { AuthService, FacebookLoginProvider, SocialUser } from 'angularx-social-login';
// import { CommonService } from '../providers/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { headerMenu, platformList, sportList } from '../shared.service';
import { CommonService } from '../providers/common.service';



@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  signupForm: FormGroup;
  center:boolean = true;

  contactusForm: FormGroup;
  submitted = false;
  signupDetails = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    confirmPassword: '',
    device_token: '-',
    device_type: '3',
    fd_username: '',
    dk_username: ''
  };

  packageList: any = [
    { package_id: 1, package_name: 'NFL', monthly_price: 4.99, annual_price: 19.99 },
    { package_id: 2, package_name: 'NBA', monthly_price: 4.99, annual_price: 19.99 },
    { package_id: 3, package_name: 'MLB', monthly_price: 4.99, annual_price: 19.99 },
    { package_id: 4, package_name: 'All 3', monthly_price: 4.99, annual_price: 19.99 }
  ];
  selectedPackageTotal = 0;

  contactDet: any = {};
  tempSignupDet: any = {
    userDetails: ''
  };
  submittedContact = false;
  deviceInfo = null;

  // user: SocialUser;
  userDet: any = {};
  activeMenu = headerMenu.account;

  handler: any = null;
  userDetails: any = {};

  preferenceDetail = {
    platform: 1,
    sport: 1,
  };

  isProfileUpdate = true;
  platformList = platformList;
  sportList = sportList;

  constructor(
    private route: Router,
    private navService: NavService,
    private api: ApiService,
    private toastr: ToastrService,
    // private authService: AuthService,
    // private commonService: CommonService,
    private SpinnerService: NgxSpinnerService,
    // private deviceService: DeviceDetectorService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.signupForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      fd_username: ['', ''],
      dk_username: ['', '']
    }, {
      validators: this.mustMatch('newPassword', 'confirmPassword')
    });

    this.contactusForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required],
      message: ['', Validators.required]
    });

    this.loadStripe();
  }

  loadStripe() {
    if (!window.document.getElementById('stripe-script')) {
      const s = window.document.createElement('script');
      s.id = 'stripe-script';
      s.type = 'text/javascript';
      s.src = 'https://checkout.stripe.com/checkout.js';
      s.onload = () => {
        this.handler = (window as any).StripeCheckout.configure({
          // key: 'pk_test_aeUUjYYcx4XNfKVW60pmHTtI',
          key: 'pk_test_51HbLWrAFcfh8Mf7ZnkhqV6q4vyKYV0bDFZC2OJ4q8IUOiT0IC4wfCTTdxB9ePnqO7jsNw5TwieJUpwqzQwMoqD3C00EzoZpAoL',
          locale: 'auto',
          token(token: any) {
            // You can access the token ID with `token.id`.
            // Get the token ID to your server-side code for use.
            // console.log(token);
            alert('Payment Success!!');
          }
        });
      };
      window.document.body.appendChild(s);
    }
  }

  mustMatch(controlName: string, MatchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[MatchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  get f() {
    return this.signupForm.controls;
  }

  get f2() {
    return this.contactusForm.controls;
  }


  onCreateAccount() {
    this.submitted = true;
    if (this.signupForm.valid) {
      // console.log('form valid');


      // this.signupDet = {
      //   device_token:'1234567',
      //   device_type:'1'
      // }

      // this.deviceInfo = this.deviceService.getDeviceInfo();
      // const isMobile = this.deviceService.isMobile();
      // const isTablet = this.deviceService.isTablet();
      // const isDesktopDevice = this.deviceService.isDesktop();
      // console.log(this.deviceInfo);
      // console.log(isMobile);
      // console.log(isTablet);
      // console.log(isDesktopDevice);

      this.tempSignupDet.userDetails = {
        FirstName: this.signupDetails.first_name,
        LastName: this.signupDetails.last_name,
        Email: this.signupDetails.email
      };
      this.SpinnerService.show();
      this.api.signUp(this.signupDetails).subscribe(data => {
        this.SpinnerService.hide();
        if (data && data.code == '100') {

          this.tempSignupDet.user_id = data.user_id;
          this.tempSignupDet.accessToken = data.accessToken;
          this.tempSignupDet.isLogin = true;
          this.tempSignupDet.isSocialLogin = false;
          this.tempSignupDet.isSignUpLogin = true;
          localStorage.setItem('userDetails', JSON.stringify(this.tempSignupDet));
          localStorage.setItem('PackageDetails', JSON.stringify(data.data.packageList));
          localStorage.setItem('userSubscriptionList', JSON.stringify(data.data.userSubscriptionList));
          // this.commonService.getProfileDetails(data.user_id);

          this.packageList = data.data.packageList;
          this.packageList.forEach(element => {
            element.isMonthlyCheck = false;
            element.isAnnualCheck = false;
          });
          this.userDetails = this.tempSignupDet;
          this.isNextClick(true);
          // this.navService.changeNav('item');
          // this.route.navigate(['/DashBoard']);
        } else {
          this.toastr.warning(data.message, 'Major Error');
        }
      }, (err) => {
        this.SpinnerService.hide();
        this.toastr.error('something went wrong', 'Major Error');
      });

    } else {
      // console.log('form invalid');
    }
  }

  getProfileDetails() {
    const data = { user_id: this.userDetails.user_id };

    this.api.getProfileDetails(data).subscribe(Data => {
      if (Data && Data.code == 100) {
        // console.log(Data.message);
        this.userDet = JSON.parse(localStorage.getItem('userDetails'));
        if (this.userDet && this.userDet.userDetails) {
          let platform, sport;
          if (Data.data.userDetails.default_platform_id == platformList.DraftKings) {
            platform = platformList[platformList.DraftKings];
          } else if (Data.data.userDetails.default_platform_id == platformList.FanDuel) {
            platform = platformList[platformList.FanDuel];
          }

          if (Data.data.userDetails.default_sport_id == sportList.NFL) {
            sport = sportList[sportList.NFL];
          } else if (Data.data.userDetails.default_sport_id == sportList.NBA) {
            sport = sportList[sportList.NBA];
          } else if (Data.data.userDetails.default_sport_id == sportList.MLB) {
            sport = sportList[sportList.MLB];
          }

          this.userDet.platformName = platform;
          this.userDet.sportName = sport;
          this.userDet.userDetails = Data.data.userDetails;
          localStorage.setItem('userDetails', JSON.stringify(this.userDet));
          this.navService.changeNav('item');
          this.toastr.success('Registration successfully', 'Success');
        }
      } else {
        // console.log(Data.message);
      }
    }, (err) => {
      // console.log('Error : ' + err);
    });
  }

  // onCreateAccountWithFB(item) {

  //   this.api.signUp(item).subscribe(data => {
  //     if (data && data.code == '100') {

  //       this.tempSignupDet.UserID = data.user_id;
  //       this.tempSignupDet.RegisterStatusCode = data.register_status_code;
  //       this.tempSignupDet.accessToken = data.accessToken;

  //       localStorage.setItem('userDetails', JSON.stringify(this.tempSignupDet));
  //       this.navService.changeNav('item');
  //       this.toastr.success(data.message, 'Success');
  //       this.route.navigate(['/DashBoard']);
  //     } else {
  //       this.toastr.warning(data.message, 'Major Error');
  //     }
  //   }, (err) => {
  //     this.toastr.error('something went wrong', 'Major Error');
  //   });
  // }

  // signUpWithFB() {
  //   this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  // }

  onSingIn() {
    this.route.navigate(['/SignIn']);
  }

  // onContactPopup() {
  //   this.submittedContact = false;
  //   this.contactDet = {};
  // }

  onContactSubmit() {
    this.submittedContact = true;
    if (this.contactusForm.valid) {
      // console.log('form valid');
    } else {
      // console.log('form invalid');
    }
  }

  onSkip() {
    if(this.activeMenu != 1){ // Skip not allowed for other steps
      return;
    }
    if (this.userDetails.user_id) {
      this.getProfileDetails();
    } else {
      const data = {
        isLogin: false,
        isSkip: true,
        platformName: platformList[platformList.DraftKings],
        sportName: sportList[sportList.NFL],
        default_platform_id: platformList.DraftKings,
        default_sport_id: sportList.NFL
      };
      this.commonService.platformandsport.sport_id = sportList.NFL;
      this.commonService.platformandsport.platform_id = platformList.DraftKings;
      localStorage.setItem('userDetails', JSON.stringify(data));
      this.navService.changeNav('item');
    }
  }

  isNextClick(isNext, isFromPackage = false) {

    if (isFromPackage) {
      this.packageList.forEach(element => {
        if (element.isMonthlyCheck) { this.selectedPackageTotal = this.selectedPackageTotal + element.monthly_price; }
        if (element.isAnnualCheck) { this.selectedPackageTotal = this.selectedPackageTotal + element.annual_price; }
      });
      if (this.selectedPackageTotal > 0) {
        this.activeMenu = isNext ? (this.activeMenu + 1) : (this.activeMenu - 1);
      } else {
        this.toastr.error('Select at least one package', 'Pick your plan');
        return;
      }

    } else {
      this.activeMenu = isNext ? (this.activeMenu + 1) : (this.activeMenu - 1);
    }
  }

  changePackage(item, isFrom) {
    if (item.package_id == 4) {
      const tmp = JSON.parse(JSON.stringify(item));
      this.packageList.forEach(element => {
        element.isMonthlyCheck = false;
        element.isAnnualCheck = false;
      });

      if (isFrom == 1) {
        if (tmp.isMonthlyCheck) { item.isMonthlyCheck = true; }
      } else {
        if (tmp.isAnnualCheck) { item.isAnnualCheck = true; }
      }
    } else {
      const tmp = this.packageList.find(m => m.package_id == 4);
      if (!tmp.isMonthlyCheck && !tmp.isAnnualCheck) {
        if (isFrom == 1) {
          if (item.isMonthlyCheck) { item.isAnnualCheck = false; }
        } else {
          if (item.isAnnualCheck) { item.isMonthlyCheck = false; }
        }
      } else {
        tmp.isAnnualCheck = false;
        tmp.isMonthlyCheck = false;
      }
    }
  }

  updatePersonalDetails() {
    if (this.isProfileUpdate) {
      const updationData = {
        first_name: this.userDetails.FirstName,
        last_name: this.userDetails.LastName,
        email: this.userDetails.Email,
        user_id: this.userDetails.user_id,
        default_sport_id: this.preferenceDetail.sport,
        default_platform_id: this.preferenceDetail.platform,
        current_password: '',
        new_password: '',
        dk_username: this.userDetails.dk_username,
        fd_username: this.userDetails.fd_username,
      };

      this.SpinnerService.show();
      this.api.updatePlatformSport(updationData).subscribe(data => {
        this.SpinnerService.hide();
        if (data && data.code == 100) {
          // this.toastr.success('Profile updated successfully', 'Success');
          this.isProfileUpdate = false;
          this.onUpgrade();
        } else {
          this.toastr.warning('Somthing went wrong', 'warning');
        }
      }, (err) => {
        this.SpinnerService.hide();
        this.toastr.error('Somthing went wrong', 'warning');
      });
    } else {
      this.onUpgrade();
    }
  }

  onUpgrade() {
    const _self = this;
    const handler = (window as any).StripeCheckout.configure({
      // key: 'pk_test_aeUUjYYcx4XNfKVW60pmHTtI',  //dummy key
      key: 'pk_test_51HbLWrAFcfh8Mf7ZnkhqV6q4vyKYV0bDFZC2OJ4q8IUOiT0IC4wfCTTdxB9ePnqO7jsNw5TwieJUpwqzQwMoqD3C00EzoZpAoL',
      locale: 'auto',
      token(token: any) {
        // console.log(token);
        _self.insertPaymentDetails(token.id, token.email);
      }
    });
    handler.open({
      name: 'Chalk Faders',
      // description: '2 widgets',
      amount: this.selectedPackageTotal * 100,
      email: this.userDetails.userDetails.Email || ''
    });
  }

  insertPaymentDetails(token, email) {
    const subscriptionItems: any = { items: [] };

    this.packageList.forEach(element => {
      const tempPlan: any = {};
      if (element.isAnnualCheck) {
        tempPlan.amount = element.annual_price;
        tempPlan.package_id = element.package_id;
        tempPlan.plan = 'year';

        subscriptionItems.items.push(tempPlan);
      } else if (element.isMonthlyCheck) {

        tempPlan.amount = element.monthly_price;
        tempPlan.package_id = element.package_id;
        tempPlan.plan = 'month';
        subscriptionItems.items.push(tempPlan);
      }
    });

    const tempData = {
      device_token: '-',
      device_type: '3',
      token,
      user_id: this.userDetails.user_id,
      referral_user_id: '',
      promo_code: '',
      email,
      name: email,
      items: JSON.stringify(subscriptionItems),
    };

    this.SpinnerService.show();
    this.api.paymentDetails(tempData).subscribe(data => {
      this.SpinnerService.hide();
      if (data && data.code == 100) {
        localStorage.setItem('userSubscriptionList', JSON.stringify(data.data.userSubscriptionList));
        this.toastr.success('Payment Success', 'success');
        this.isNextClick(true);
      } else {
        this.toastr.warning('Somthing went wrong', 'Warning');
      }
    }, (err) => {
      this.SpinnerService.hide();
      // console.log(err);
    });
  }

}
